<template>
  <v-container class="pa-0" style="max-width:480px">
    <v-row
      class="py-3 borderBottom"
      justify="center"
      no-gutters
      v-for="(prod,i) in itemsCarrito"
      :key="i"
      :index="items"
    >
      <v-col class="pa-0 ma-0" cols="2" style="max-width:54px;">
        <v-select
          style="margin-top:4px !important;"
          hide-details
          class="pa-0 ma-0 font-weight-medium"
          v-if="opciones.select"
          :items="cantidadSelect(prod.cantidad)"
          :value="prod.cantidad.toString()"
          :key="prod.nombre"
          item-text="text"
          item-value="val"
          :menu-props="{ maxHeight: 'auto' }"
          @change="changeQuantity($event, prod.id, i)"
        >
          <template slot="append">
            <v-icon class="subtitle-1 lighten-4--text mt-1">mdi-chevron-down</v-icon>
          </template>
        </v-select>
        <v-list-item-title class="mt-2 font-weight-medium" v-else>
          {{ prod.cantidad.toString() }}
          <span class="grey--text font-weight-regular">x</span>
        </v-list-item-title>
      </v-col>
      <v-col cols class="pl-4 py-2 text-truncate">
        <v-list-item-title class="font-weight-medium">{{ prod.nombre }}</v-list-item-title>
        <v-list-item-subtitle class v-for="opcion in prod.opcionesName" :key="opcion">-- {{opcion}}</v-list-item-subtitle>
      </v-col>
      <v-col cols class style="max-width:76px">
        <v-list-item-title
          class="text-end py-2 font-weight-medium"
        >{{ replaceComa( (prod.cantidad*(sumaOpciones(prod.opcionesPrecio)+parseFloat(prod.precio))).toFixed(2) ) }} €</v-list-item-title>
      </v-col>
    </v-row>

    <v-list v-if="opciones.totales" class="h-100" color="transparent">
      <!-- Total y Subtotal -->
      <!--<v-list-item class="ma-0 pa-0">
        <v-row class no-gutters>
          <v-col offset="0" cols="12" class="mb-4 mt-2">
            <v-text-field hide-details outlined label="Código de descuento"></v-text-field>
          </v-col>
        </v-row>
      </v-list-item>-->
      <v-divider></v-divider>
      <v-list-item class="ma-0 pa-0">
        <v-row no-gutters class="grey--text">
          <v-col cols="6">Subtotal</v-col>
          <v-col
            class="nowrap_space d-flex justify-end ma-0 grey--text"
            cols="6"
          >{{ calculoPrecioTotal != undefined ? (calculoPrecioTotal - calculoImpuestosCarrito).toFixed(2) : '0.00'}} €</v-col>
        </v-row>
      </v-list-item>
      <v-list-item class="ma-0 pa-0">
        <v-row no-gutters class="grey--text">
          <v-col cols="6" class="pa-0 ma-0">{{ getImpuestoTexto }}</v-col>
          <v-col
            class="nowrap_space d-flex justify-end ma-0 grey--text pa-0 ma-0"
            cols="6"
          >{{ calculoPrecioTotal != undefined ? (calculoImpuestosCarrito).toFixed(2) : '0.00'}} €</v-col>
        </v-row>
      </v-list-item>

      <v-list-item class="headline pa-0 ma-0">
        <v-row no-gutters class="headline pb-4">
          <v-col cols="6">Total</v-col>
          <v-col
            class="nowrap_space d-flex justify-end ma-0 headline"
            cols="6"
          >{{ calculoPrecioTotal != undefined ? calculoPrecioTotal.toFixed(2) : '0.00'}} €</v-col>
        </v-row>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "pedirCarritoContenido",
  components: {},
  props: {
    opciones: Object
  },
  data() {
    return {
      items: [],
      cantidadProducto: [
        { val: "0", text: "Eliminar" },
        { val: "1", text: "1x" },
        { val: "2", text: "2x" },
        { val: "3", text: "3x" },
        { val: "4", text: "4x" },
        { val: "5", text: "5x" },
        { val: "6", text: "6x" },
        { val: "7", text: "7x" },
        { val: "8", text: "8x" },
        { val: "9", text: "9x" },
        { val: "10", text: "10x" }
      ]
    };
  },
  computed: {
    ...mapState({
      carrito: state => state.pedido.carrito,
      carritoUltimoPedido: state => state.pedido.ultimosPedidos[0],
      loadingCarrito: state => state.pedido.loadingCarrito,
      cantidad: state => state.pedido.carrito.numero_producto,
      loadingQuantity: state => state.pedido.loadingQuantity,
      carritoComprobadoServidor: state => state.pedido.carritoComprobadoServidor
    }),
    ...mapGetters({
      impuestosCarrito: "pedido/calculoImpuestosCarrito",
      impuestosUltimoPedido: "pedido/calculoImpuestosUltimoPedido"
    }),
    itemsCarrito() {
      let res = this.carrito.productos;
      if (this.opciones.isResumen) res = this.carritoUltimoPedido.productos;
      if (this.opciones.isComprobar)
        res = this.carritoComprobadoServidor.productos;
      return res;
    },
    calculoImpuestosCarrito() {
      let res = this.impuestosCarrito;
      if (this.opciones.isResumen) res = this.impuestosUltimoPedido;
      if (this.opciones.isComprobar)
        res = this.carritoComprobadoServidor.impuestosTotal;
      //res = this.carritoComprobadoServidor.impuestos;
      return res;
    },
    calculoPrecioTotal() {
      let res = this.carrito.precio_total;
      if (this.opciones.isResumen) res = this.carritoUltimoPedido.precioTotal;
      if (this.opciones.isComprobar)
        res = this.carritoComprobadoServidor.precio_total;
      return res;
    },
    getImpuestoTexto() {
      const impuestos = this.$store.state.restaurante.impuestos;
      const restObj = this.$store.state.pedido.restauranteObjPedido;
      var found = impuestos.find(i => (i.id = restObj.impuesto));
      if (found) {
        return found.nombre.replace(/ .*/, "");
      } else {
        return "";
      }
    }
  },

  methods: {
    breadcrumbOpciones(opciones) {
      let bread = "";
      opciones.forEach(function(e, i) {
        bread += e;
        i != opciones.length - 1 ? (bread += " / ") : "";
      });
      return bread;
    },
    replaceComa(str) {
      return str
        .toString()
        .trim()
        .replace(".", ",");
    },
    changeQuantity(cant, id, indexArray) {
      const _vue = this;
      let payload = { id: id, cant: parseInt(cant), indexArray: indexArray };

      _vue.$store.commit("pedido/setLoadingQuantity", true);
      _vue.$store
        .dispatch("pedido/setCantidadProducto", payload)
        .then(function() {})
        .catch(function() {})
        .finally(function() {
          _vue.$store.commit("pedido/setLoadingQuantity", false);
        });
    },
    sumaOpciones(array) {
      if (array.length > 0) {
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        return array.reduce(reducer);
      } else {
        return 0;
      }
    },
    cantidadSelect(num) {
      let res = this.cantidadProducto;
      let temp = [{ val: num.toString(), text: num.toString() + "x" }];
      if (num > res.length - 1) {
        return res.concat(temp);
      } else {
        return res;
      }
    }
  },
  mounted() {}
};
</script>

<style scoped>
.w-100 {
  width: 100%;
}
.border {
  border: 1px solid #000;
}
.borderBottom {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.12);
}
.v-list-item__content {
  -ms-flex-item-align: stretch;
  align-self: start;
}
.v-input__slot {
  margin-bottom: 0px;
}
.v-messages {
  min-height: 0px;
}
</style>
